import type { Graph } from './graph'

export class Layout<O> {
  graph: Graph
  options: O

  protected executeId = 0
  protected resolvers = new Map<number, () => void>()

  constructor(graph: Layout<O>['graph'], options?: Layout<O>['options']) {
    this.graph = graph
    this.options = options ?? ({} as O)
  }

  setResolver = (resolver: () => void) => {
    this.executeId += 1
    this.resolvers.set(this.executeId, resolver)
  }

  resolve = () => {
    const resolver = this.resolvers.get(this.executeId)

    if (resolver) {
      resolver()
      this.resolvers.delete(this.executeId)
    }
  }
}
